// extracted by mini-css-extract-plugin
export var animation_spin = "index-module--animation_spin--5920e";
export var btn_icon = "index-module--btn_icon--0fe4a";
export var input_error = "index-module--input_error--b3659";
export var input_error_icon = "index-module--input_error_icon--1ce76";
export var newsletter_banner = "index-module--newsletter_banner--a0c0c";
export var newsletter_btn_submit = "index-module--newsletter_btn_submit--41be2";
export var newsletter_desc = "index-module--newsletter_desc--25e9c";
export var newsletter_form = "index-module--newsletter_form--90bc1";
export var newsletter_form_input = "index-module--newsletter_form_input--52ad0";
export var newsletter_img = "index-module--newsletter_img--9fae9";
export var newsletter_operation_wrap = "index-module--newsletter_operation_wrap--c075b";
export var newsletter_success_wrap = "index-module--newsletter_success_wrap--f0f95";
export var newsletter_tip = "index-module--newsletter_tip--31296";
export var newsletter_title = "index-module--newsletter_title--93bcb";
export var newsletter_wrap = "index-module--newsletter_wrap--b9dfe";
export var spin = "index-module--spin--3d543";
export var success_text = "index-module--success_text--8f372";